import auctionUser from "./auctionUser";
import bidSubscriptionResponse from "./bidSubscriptionResponse";
import fixedItemSubscriptionResponse from "./fixedItemSubscriptionResponse";
import donationSubscriptionResponse from "./donationSubscriptionResponse";
import liveAuctionCode from "./liveAuctionCode";

export const auctionReducers = { auctionUser, bidSubscriptionResponse, fixedItemSubscriptionResponse, donationSubscriptionResponse, liveAuctionCode };